module.exports = __webpack_public_path__ + "static/iphonex-engaging-0035341e877e579467c138d43dcd6f43.png";